import * as React from 'react'

import { cn } from '@/lib/utils'

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          `
            resize-none
            flex
            min-h-[80px]
            w-full
            rounded-md
            border
            border-border-strong-2
            bg-field-2
            px-3
            py-2
            text-base
            placeholder:text-muted-foreground
            focus-visible:border-focus
            focus-visible:outline-none
            focus-visible:ring-1
            focus-visible:ring-focus
            disabled:cursor-not-allowed
            disabled:opacity-50
          `,
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
